import { NavLink, Outlet } from 'react-router-dom';
import { Icon, type IconName } from '@/components/ui/Icon';
import { useAuth } from '@/context/AuthContext';
import { STORE_URL } from '@/lib/env';
import styles from './AdminLayout.module.css';

const NAV: { to: string; label: string; icon: IconName; end?: boolean }[] = [
  { to: '/', label: 'Dashboard', icon: 'dashboard', end: true },
  { to: '/products', label: 'Products', icon: 'box' },
  { to: '/orders', label: 'Orders', icon: 'receipt' },
  { to: '/inventory', label: 'Inventory', icon: 'layers' },
];

export function AdminLayout() {
  const { username, logout } = useAuth();
  return (
    <div className={styles.shell}>
      <aside className={styles.sidebar}>
        <div className={styles.brand}>
          <span className={styles.logo} aria-hidden="true">
            🌿
          </span>
          <span>
            <span className={styles.brandName}>
              Kon<b>Store</b>
            </span>
            <span className={styles.tag}>Admin</span>
          </span>
        </div>

        <nav className={styles.nav} aria-label="Admin sections">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ''}`}
            >
              <Icon name={item.icon} size={20} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className={styles.spacer} />
        <div className={styles.foot}>
          <a
            className={styles.storeLink}
            href={STORE_URL}
            target="_blank"
            rel="noreferrer noopener"
          >
            <Icon name="external" size={16} />
            View storefront
          </a>
          <button type="button" className={styles.logoutBtn} onClick={logout}>
            <Icon name="logout" size={16} />
            Sign out{username ? ` (${username})` : ''}
          </button>
        </div>
      </aside>

      <div className={styles.main}>
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
